import s from './Table.module.scss';
import {ColumnObject, TTableProps} from "@/app/[locale]/common/components/Table/types";
import {ELEMENT_INDEX} from "../../constants/app";

const renderColumnContent = (column: ColumnObject | null) => {
    if (!column || !column.list) return null;

    return (
        <>
            {column.title && <span>{column.title}</span>}
            <ul className={s.table_list}>
                {column.list.map((listItem, index) => (
                    <li key={index}>{listItem}</li>
                ))}
            </ul>
        </>
    );
};

export const Table = ({  headerSize = 'small', mobileWidth = 'medium', firstColumnFontWeight, centerAlignColumns = false, data }: TTableProps) => {
    const columnAlignmentClass = centerAlignColumns ? s.table_columnPosition: '';
    const firstColumnClass = firstColumnFontWeight ? s.table_firstColumn : '';

    return (
        <div className={s.tableContainer}>
            <table className={`${s.table} ${s[`table_${mobileWidth}`]}`}>
                <thead>
                <tr className={`${s.table_head} ${s[`table_head_${headerSize}`]}`}>
                    {
                        data.LABELS.map((item: string, index: number) => (
                            <th key={index} className={`${index > ELEMENT_INDEX.FIRST && columnAlignmentClass}`}>{item}</th>
                        ))
                    }
                </tr>
                </thead>
                <tbody>
                {data.CONTENT.map((row: Record<string, string | ColumnObject>, rowIndex: number) => (
                    <tr key={rowIndex}>
                        {Object.keys(row).map((key: string, colIndex: number) => (
                            <td key={colIndex} data-label={data.LABELS[colIndex]} className={`${colIndex === ELEMENT_INDEX.FIRST && firstColumnClass} ${colIndex > ELEMENT_INDEX.FIRST && columnAlignmentClass}`}>
                                {typeof row[key] === 'string'
                                    ? row[key]
                                    : renderColumnContent(row[key] as ColumnObject)}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};